import ReportBugPage from '@/modules/report-bug/report-bug-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/report-bug/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ReportBugPage />;
}
